import { render, staticRenderFns } from "./IntegrationSidebar.vue?vue&type=template&id=fc81cd10"
import script from "./IntegrationSidebar.vue?vue&type=script&lang=js"
export * from "./IntegrationSidebar.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSidebar.vue?vue&type=style&index=0&id=fc81cd10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports